import React from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes, defaultProps } from 'recompose';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import styles from './Validation.scss';

const ERROR_MESSAGES = [
  'API Authentication Failure: Invalid Authentication Type/Credentials Provided',
  'The email is already in use.',
];

export const Validation = ({
  touched,
  error,
  novalidate,
  submitValidate,
  children,
  customError,
  ignoreOthers,
}) => {
  const CustomError = customError;
  return (
    <div>
      <div className={styles.container}>
        {children}
        {
          !novalidate && touched && !submitValidate &&
          <div className={styles.validation}>
            <span
              className={classNames(
                styles.icon,
                error ? styles.error : styles.success,
              )}
            >
              {
                error &&
                <Svg
                  iconName="cross"
                  size="Medium"
                />
              }
              {
                !error &&
                <Svg
                  iconName="tick"
                  size="Medium"
                />
              }
            </span>
          </div>
        }
        {
          submitValidate && touched &&
          <div className={styles.validation}>
            <span
              className={classNames(
                styles.icon,
                error && styles.error,
              )}
            >
              {
                error &&
                <Svg
                  iconName="cross"
                  size="Medium"
                />
              }
            </span>
          </div>
        }
      </div>
      {
        !novalidate && touched && error && !submitValidate &&
        <div className={styles.comment}>
          {
            CustomError &&
            (ignoreOthers || ERROR_MESSAGES.indexOf(error) > -1) ?
              <CustomError /> :
              error
          }
        </div>
      }
      {
        touched && error && submitValidate &&
        <div className={styles.comment}>
          {
            CustomError &&
            (ignoreOthers || ERROR_MESSAGES.indexOf(error) > -1) ?
              <CustomError /> :
              error
          }
        </div>
      }
    </div>
  );
};

export default compose(
  setDisplayName('Validation'),
  defaultProps({
    error: '',
    novalidate: false,
  }),
  setPropTypes({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
    novalidate: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element),
    ]).isRequired,
  }),
)(Validation);
